import React, { useState, useEffect } from 'react';
import { Button, Card, Row, Col, Container } from 'react-bootstrap';
import { useParams, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { default as Selector } from 'react-select';
import {buscarParametrosPDV,buscarParametrosPdvLancamento,BuscarEmpreendimentosPDV,buscarParametrosEspecifico,buscarCheques,buscarAlcadaAtiva,buscarTabelaAlcada,} from '~/Services/Service';
import TelaMapaEmpreendimento from '~/Components/PdvParametros/TelaMapaEmpreendimento';
import TelaLancamento from '~/Components/PdvParametros/TelaLancamento';
import TelaChequeBonus from '~/Components/PdvParametros/TelaChequeBonus';
import TelaAlcadas from '~/Components/PdvParametros/TelaAlcadas';
import Header from '~/Components/Header/Header';
import { FaArrowLeft } from 'react-icons/fa';

const ParametrosDetalhes = () => {
  const { id: empreendimentoId } = useParams();
  const [loading, setLoading] = useState(false);
  const [empreendimentoData, setEmpreendimentoData] = useState(null);
  const [error, setError] = useState(null);
  const [activeCard, setActiveCard] = useState(null);
  const [mapaData, setMapaData] = useState(null);
  const [lancamentoData, setLancamentoData] = useState(null);
  const [lancamentoEspecificoData, setLancamentoEspecificoData] = useState([]);
  const [chequesData, setChequesData] = useState([]);
  const [alcadasData, setAlcadasData] = useState(null);
  const [alcadasDataLista, setAlcadasDataLista] = useState(null);
  const [empreendimentos, setEmpreendimentos] = useState([]);
  const history = useHistory();

  useEffect(() => {
    const carregarEmpreendimentos = async () => {
      try {
        const dados = await BuscarEmpreendimentosPDV();
        setEmpreendimentos(dados || []);
      } catch (error) {
        console.error('Erro ao carregar empreendimentos:', error);
      }
    };
    carregarEmpreendimentos();
  }, []);

  useEffect(() => {
    setActiveCard(null);
  }, [empreendimentoId]);

  const corretores = useSelector(state => state.corretor);

  const optionsEmpreendimentos = empreendimentos.map(item => ({
    value: item.codigo,
    label: item.codigo + ' - ' + item.descricao,
  }));

  const optionsCorretores = [
    ...corretores.listaCorretores.map(cor => ({
      value: cor.codigo,
      label: cor.codigo + ' - ' + cor.nome,
    })),
  ];

  const voltarParaLista = () => {
    history.push('/parametrospdv');
  };

  const fetchLancamentoData = async () => {
    try {
      setLoading(true);
      const [data, especificoData] = await Promise.all([
        buscarParametrosPdvLancamento(empreendimentoId),
        buscarParametrosEspecifico(empreendimentoId)
      ]);
      setLancamentoData(data);
      setLancamentoEspecificoData(especificoData || []);
    } catch (error) {
      console.error('Erro ao buscar parâmetros de lançamento:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchChequesData = async () => {
    try {
      setLoading(true);
      const data = await buscarCheques(empreendimentoId);
      setChequesData(data || []);
    } catch (error) {
      console.error('Erro ao buscar cheques:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAlcadasData = async () => {
    try {
      setLoading(true);
      const [data, dataTabela] = await Promise.all([
        buscarAlcadaAtiva(empreendimentoId),
        buscarTabelaAlcada(empreendimentoId),
      ]);
      setAlcadasData(data || null);
      setAlcadasDataLista(dataTabela || []);
    } catch (error) {
      console.error('Erro ao buscar alçadas:', error);
      setAlcadasData(null);
    } finally {
      setLoading(false);
    }
  };

  const handleCardClick = async cardType => {
    if (cardType === 'mapa' && activeCard !== 'mapa') {
      try {
        setLoading(true);
        const data = await buscarParametrosPDV(empreendimentoId);
        setMapaData(data);
      } catch (error) {
        console.error('Erro ao buscar parâmetros PDV:', error);
      } finally {
        setLoading(false);
      }
    } else if (cardType === 'lancamento' && activeCard !== 'lancamento') {
      await fetchLancamentoData();
    } else if (cardType === 'cheque' && activeCard !== 'cheque') {
      await fetchChequesData();
    } else if (cardType === 'alcadas' && activeCard !== 'alcadas') {
      await fetchAlcadasData();
    }
    setActiveCard(activeCard === cardType ? null : cardType);
  };

  const renderActiveScreen = () => {
    switch (activeCard) {
      case 'mapa':
        const empreendimentoSelecionado = empreendimentos.find(
          item => String(item.codigo) === String(empreendimentoId)
        );
        const nome_familia = empreendimentoSelecionado
          ? empreendimentoSelecionado.descricao
          : '';

        return (
          <TelaMapaEmpreendimento
            empreendimentoId={empreendimentoId}
            empreendimentoData={mapaData || empreendimentoData}
            nome_familia={nome_familia}
            voltarParaLista={voltarParaLista}
          />
        );
      case 'lancamento':
        return (
          <TelaLancamento
            empreendimentoId={empreendimentoId}
            optionsCorretores={optionsCorretores}
            lancamentoData={lancamentoData}
            lancamentoEspecificoData={lancamentoEspecificoData}
            onRefresh={fetchLancamentoData}
          />
        );
      case 'cheque':
        return (
          <TelaChequeBonus
            empreendimentoId={empreendimentoId}
            chequesData={chequesData}
            onRefresh={fetchChequesData}
          />
        );
      case 'alcadas':
        return (
          <TelaAlcadas
            empreendimentoId={empreendimentoId}
            alcadasData={alcadasData}
            alcadasDataLista={alcadasDataLista}
            onRefresh={fetchAlcadasData}
          />
        );
      default:
        return null;
    }
  };

  const cards = [
    {
      type: 'mapa',
      title: 'Mapa do empreendimento',
      text:
        'Configurações básicas do mapa do empreendimento: Tabela padrão, quant. de reserva, tempo da reserva e etc',
      icon:
        'https://repositorio.setcorp.com.br/imagens/icones/svg/sale-param.svg',
    },
    {
      type: 'lancamento',
      title: 'Lançamento',
      text:
        'Configurações do lançamento como: Periodo, tipo de atendimento, cheque bonus e etc',
      icon: 'https://www.revobrasil.com.br/Extranet/Layout/svg/browser.svg',
    },
    {
      type: 'cheque',
      title: 'Cheque Bônus',
      text: 'Manutenção de cheque bônus',
      icon: 'https://www.revobrasil.com.br/Extranet/Layout/svg/clerk.svg',
    },
    {
      type: 'alcadas',
      title: 'Alçadas do Empreendimento',
      text:
        'Configure as alçadas de desconto dos corretores e gerentes de imobiliária para este empreendimento',
      icon: 'https://www.revobrasil.com.br/Extranet/Layout/svg/discount.svg',
    },
  ];

  return (
    <div>
      <Container fluid className="px-3 py-3">
        <Row
          className="py-3 mb-3 mx-auto justify-content-between align-items-center"
          style={{
            backgroundColor: '#0747a6',
            borderRadius: '8px',
            color: '#fff',
          }}
        >
          <Col className="d-flex align-items-center justify-content-between px-3">
            <h4 className="mb-0">Parâmetros do Empreendimento</h4>
          </Col>
          <Col xs={12} md="auto" className="mb-2 mb-md-0">
            <Button
              variant="success"
              size="sm"
              onClick={voltarParaLista}
              className="w-100 w-md-auto d-flex align-items-center "
            >
              <FaArrowLeft />
            </Button>
          </Col>
          <Col xs={12} md={6} lg={5}>
            <Selector
              inputId="selector-emp"
              styles={customStyles}
              components={{ DropdownIndicator }}
              name="empreendimento"
              isSearchable={true}
              isClearable={false}
              options={optionsEmpreendimentos}
              value={optionsEmpreendimentos.find(
                item => String(item.value) === String(empreendimentoId)
              )}
              onChange={selected => {
                if (selected) {
                  history.push(
                    `/parametrospdv/parametrosdetalhes/${selected.value}`
                  );
                }
              }}
              placeholder="Selecione..."
            />
          </Col>
        </Row>
        {!loading && !error && (
          <>
            <Row>
              {cards.map(card => {
                const isSelected = activeCard === card.type;
                return (
                  <Col key={card.type} xs={12} sm={6} lg={3} className="mb-3">
                    <Card
                      className={`h-100 ${isSelected ? 'border-primary shadow' : ''
                        }`}
                      onClick={() => handleCardClick(card.type)}
                      style={{
                        cursor: 'pointer',
                        transition: 'all 0.2s ease-in-out',
                        borderWidth: isSelected ? '2px' : '1px',
                      }}
                    >
                      <Card.Header
                        className={`py-2 ${isSelected ? 'bg-primary text-white' : ''
                          }`}
                      >
                        <Card.Title
                          className={`text-uppercase text-center mb-0 ${isSelected ? 'text-white' : 'text-primary'
                            }`}
                          style={{ fontSize: '1rem' }}
                        >
                          {card.title}
                        </Card.Title>
                      </Card.Header>
                      <Card.Body
                        className={`d-flex flex-column align-items-center justify-content-between ${isSelected ? 'bg-light' : ''
                          }`}
                      >
                        <Card.Text className="text-center small">
                          {card.text}
                        </Card.Text>
                        <img
                          src={card.icon}
                          alt={card.title}
                          className="mt-2"
                          style={{
                            width: '48px',
                            height: '48px',
                            objectFit: 'contain',
                            opacity: isSelected ? 1 : 0.7,
                          }}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
            <div className="mt-3">{renderActiveScreen()}</div>
          </>
        )}
      </Container>
    </div>
  );
};

export default ParametrosDetalhes;
